export const ru = {
    'campaign-group': 'Кампания/группа',
    'campaign-type': 'Тип кампании',
    name: 'Название',
    'price-context': 'Ставка за тыс. показов,{currency}',
    'user-profile-condition': 'Условия показа'
};
